module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/usaa@3x.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/usaa@3x.png
// module id = 1196
// module chunks = 0